import { HttpClient } from '@angular/common/http';
import { TranslateLoader } from '@ngx-translate/core';
import { forkJoin, Observable, of, throwError } from 'rxjs';
import { catchError, map, mergeMap, retry } from 'rxjs/operators';
import { CommonTranslationService, ITranslationResource, TranslationResourceModel } from './common-translation.service';
import {ShellDomainProvider} from "@ecap3/core";


export class MultiTranslateHttpLoaderV2 implements TranslateLoader {
    langArray: any[] = [];
    lastLanguage: any;
    commonLanguage: any;

    constructor(private http: HttpClient, private resources: ITranslationResource[]) {}

    public getTranslation(lang: string): Observable<any> {
        const useBlocksUilm = ShellDomainProvider['api'].UseBlocksUilm;
        const commonTranslationResource = new TranslationResourceModel('generic-app');
        let hasCommonTranslations = false;
        let commonTranslationIndexInResource = -1;
        if (CommonTranslationService.lastLanguage !== lang) {
            CommonTranslationService.translation = undefined;
        }
        if(useBlocksUilm && lang=="cz"){
          lang="cs";
        }
        CommonTranslationService.lastLanguage = lang;
        if (CommonTranslationService.translation) {
            hasCommonTranslations = true;
            this.resources.filter(item => {
                return item.prefix !== commonTranslationResource.prefix;
            });
        } else {
            commonTranslationIndexInResource = this.resources.findIndex(item => {
                return item.prefix === commonTranslationResource.prefix;
            });
            if (commonTranslationIndexInResource === -1) {
                commonTranslationIndexInResource = this.resources.length;
                this.resources.push(commonTranslationResource);
            }
        }

        let retryCounts = this.resources.map(_ => 0);
        let maxRetryCount = 5;

        const requests = this.resources.map((resource, index) => {
            const path = resource.prefix + lang + resource.suffix;
            return this.http.get(path, { withCredentials: true }).pipe(
                mergeMap(val => {
                    if(!val && retryCounts[index] < maxRetryCount) {
                        retryCounts[index]++;
                        console.error('Could not find translation file:', path);
                        return throwError('Could not find translation file: ' + path);
                    }
                    return of(val);
                }),
                retry(maxRetryCount),
                catchError(res => {
                    console.error('Could not find translation file:', path);
                    return of({});
                })
            );
        });
        return forkJoin(requests).pipe(
            map(responseJsons => {
                responseJsons = responseJsons.filter(res => res !== null);
                let mergeAll = {};
                if (hasCommonTranslations) {
                    mergeAll = CommonTranslationService.translation;
                } else {
                    CommonTranslationService.translation = responseJsons[commonTranslationIndexInResource];
                }
                responseJsons.forEach(response => this.mergeDeep(mergeAll, response));
                // printJson(mergeAll);
                return mergeAll;
            })
        );
    }

    mergeDeep(target, source) {
        if (typeof target === 'object' && typeof source === 'object') {
            Object.keys(source).forEach(key => {
                if (source[key] === null && (target[key] === undefined || target[key] === null)) {
                    target[key] = null;
                } else if (source[key] instanceof Array) {
                    if (!target[key]) {
                        target[key] = [];
                    }
                    target[key] = target[key].concat(source[key]);
                } else if (typeof source[key] === 'object') {
                    if (!target[key]) {
                        target[key] = {};
                    }
                    this.mergeDeep(target[key], source[key]);
                } else {
                    target[key] = source[key];
                }
            });
        }
        return target;
    }
}
